import { Component, OnInit, Input } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';

import { MinhaAgenda } from '@app/models/minha-agenda';
import { IdDescricao } from '@app/models/util/id-descricao';

@Component({
  selector: 'app-mov-audiencia',
  templateUrl: './mov-audiencia.component.html',
  styleUrls: ['./mov-audiencia.component.scss']
})
export class MovAudienciaComponent implements OnInit {

  @Input() audiencias: MinhaAgenda[];
  @Input() lstUsuarios: IdDescricao[];
  @Input() form: boolean = false;
  cdsMask: CDSMask = new CDSMask();
  exibir: boolean = false;
  constructor() { }

  ngOnInit() {
    if (this.form)
      this.exibir = true;
  }

  adicionar(descricao: string) {
    let aud = new MinhaAgenda(descricao);
    aud.UsuarioId = 0;
    aud.ExtraUsuarioId = 0;

    this.audiencias.push(aud);
    this.focaCampoDataUltimaAudiencia();
  }

  remover(index: number) {
    this.audiencias.splice(index, 1);
    this.focaCampoDataUltimaAudiencia(index);
  }

  focaCampoDataUltimaAudiencia(index: number = -1): void {
    const stringUltimo = `audiencia.DataAgendada${this.audiencias.length - 1}`;
    const stringIndex = `audiencia.DataAgendada${index === 0 ? 0 : index - 1}`

    window.setTimeout(
      () => document.getElementById(index === -1 ? stringUltimo : stringIndex).focus(),
      0
    );
  }
}
